export default "__VITE_PUBLIC_ASSET__88ebb4b3__"